import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src = "/simplyalpha-logo.webp",
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img className="mx-auto w-9" alt="Simply Alpha Capital" title="Simply Alpha Capital" src="/simplyalpha-icon.png" />
        ) : (
          <img
            className={classNames(small ? "h-4 w-auto" : "h-5 w-auto")}
            alt="Simply Alpha Capital"
            title="Simply Alpha Capital"
            src={src}
          />
        )}
      </strong>
    </h3>
  );
}
